import { isEpmty } from "../helper/TextHelper";
import { httpClient } from "./RestService";

export const create = async (request) => {
  return await httpClient().post("/v1/education/instructor/casestudy", request);
};

export const upsertBaseInfo = async (request) => {
  if (isEpmty(request.id)) {
    return await httpClient().post(
      "/v1/education/instructor/casestudy/binf",
      request
    );
  } else {
    return await httpClient().put(
      "/v1/education/instructor/casestudy/binf",
      request
    );
  }
};

export const getPurchaseDetails = async (id, assignmentId) => {
  return await httpClient().get(
    "/v1/education/casestudy/purchase/" + id + "/" + assignmentId
  );
};

export const unlock = async (caseStudyId) => {
  return await httpClient().post(
    "/v1/education/casestudy/purchase/unlock",
    caseStudyId,
    {
      headers: {
        "Content-Type": "application/json", // application/json will put double quote around
      },
    }
  );
};

export const getClientSecret = async (data) => {
  return httpClient().post("/v1/education/casestudy/purchase/cs", data);
};

// export const getTeachingNotes = async (caseStudyId) => {
//   return await httpClient(true).get(
//     "/v1/education/instructor/casestudy/tn/" + caseStudyId
//   );
// };

export const getPdf = async (caseStudyId, paymentStatus, caseStudyType) => {
  return await httpClient(true).get(
    "/v1/education/instructor/casestudy/pdf/" +
      caseStudyId +
      "?ps=" +
      paymentStatus +
      "&csType=" +
      caseStudyType
  );
};

export const getGuideline = async (
  caseStudyId,
  caseStudyType,
  assignmentId
) => {
  return await httpClient(true).get(
    "/v1/education/instructor/casestudy/pdf/guideline/" +
      caseStudyId +
      "/" +
      assignmentId +
      "?csType=" +
      caseStudyType
  );
};

export const del = async (id) => {
  return await httpClient().delete("/v1/education/instructor/casestudy/" + id);
};
